import { useState } from 'react';

export const useLocalStorage = (initialState, key) => {
  const rawStateFromStorage = localStorage.getItem(key);
  const stateFromStorage =
    rawStateFromStorage && JSON.parse(rawStateFromStorage);

  const [value, setValue] = useState(
    stateFromStorage || initialState,
  );

  return [
    value,
    (data) => {
      localStorage.setItem(key, JSON.stringify(data));
      setValue(data);
    },
  ];
};

export function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    function (event) {
      setValues({
        ...fields,
        [event.target.id]: event.target.value,
      });
    },
  ];
}
